import React, { useCallback, useEffect, useRef } from "react";
import useUserState from "../hooks/useUserState";
import useBDocTranslator from "../hooks/useBDocTranslator";
import { refineConsultationText } from "../../services/services";
import useDictation from "./dictation/useDictation";
import DictationPanel, { DictationStartButton } from "./dictation/DictationPanel";

export default function ConsultationNotesEditor({
  value,
  onChange,
  placeholder,
  rows = 10,
  textareaClassName = "mb-3 w-100 h-60-custom form-control col-md-12",
}) {
  const userLocalState = useUserState();
  const { t, language } = useBDocTranslator();
  const aiEnabled = userLocalState[0]?.extendedData?.ai_enabled || false;

  // Valor y callback más recientes: el texto dictado se agrega a lo que hay
  // en la nota al momento de insertar, no a lo que había al empezar.
  const valueRef = useRef(value);
  const onChangeRef = useRef(onChange);
  useEffect(() => {
    valueRef.current = value;
    onChangeRef.current = onChange;
  });

  const jwt = userLocalState[0]?.jwt;
  const refine = useCallback(
    (rawText) => refineConsultationText(rawText, language || "es", jwt),
    [language, jwt]
  );

  const handleInsert = useCallback((text) => {
    const current = valueRef.current || "";
    onChangeRef.current(current.trim() ? current + "\n" + text : text);
  }, []);

  const dictation = useDictation({
    language: language || "es",
    refine,
    onInsert: handleInsert,
  });

  return (
    <div style={{ width: "100%" }}>
      {aiEnabled && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            marginBottom: "8px",
          }}
        >
          <div>
            <DictationStartButton dictation={dictation} />
          </div>
          <DictationPanel dictation={dictation} />
        </div>
      )}
      <textarea
        name="consultation-notes-txt"
        id="consultation-notes-txt"
        rows={rows}
        placeholder={placeholder || t("Consultation Notes Here...")}
        className={textareaClassName}
        onChange={(e) => onChange(e.target.value)}
        value={value}
      />
    </div>
  );
}
